import React from 'react'
import { Button } from 'react-bootstrap';

const SkipButton = ({ onClick, buttonName, style }) => {
    return (
        <Button
            onClick={onClick}
            style={style}
            className='skip-btn'
        >

            {buttonName}
        </Button>
    )
}

export default SkipButton;